import { Component, OnInit, Input,
         Output, EventEmitter }    from '@angular/core';
import { FormGroup, FormControl, FormArray,
         FormBuilder, Validators } from '@angular/forms';

import { CsvService }              from './../../csv.service';
import { User }                    from './../../../../models/program/user';
import { Router }                  from '@angular/router';
import { ErrorService }            from '../../../../shared/services/error.service';
import { BatchResponse }           from '../../../../models/program/batch-response';
import { BatchCommitInfo }         from '../../../../models/program/batch-commit-info';

@Component({
  selector: 'app-batch-assign-users-teams',
  templateUrl: './batch-assign-users-teams.component.html',
  styleUrls: ['./batch-assign-users-teams.component.less']
})

export class BatchAssignUsersTeamsComponent implements OnInit {
  @Input() batchResponse: BatchResponse;
  @Input() programId: number;
  @Input() sessionId: number;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  public existingUsers: User[];
  public batchForm: FormGroup;
  public usersToMove: number[] = [];
  public errors: string[];
  public saving: boolean;

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private csvService: CsvService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.batchForm = this._fb.group({
      batch_ref: [this.batchResponse.batch_ref, <any>Validators.required],
    });

  }

  /**
   * Public methods
   */

  public resetData(bool: boolean): void {
    this.reset.emit(bool);
  }

  public commitBatch(): void {
    this.saving = true;
    this.csvService.commitBatchAssignUsersTeams(
      this.programId,
      this.sessionId,
      {commit_info: this.batchForm.value as BatchCommitInfo}
    )
    .subscribe(res => {
      this.saving = false;
      this.reset.emit(true);
    }, error => {
      this.saving = false;
      this.errors = this.errorService.messages(error);
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/batch/batch-assign-users-teams.component.ts